import { IconWrapper } from '../runtime';
export default IconWrapper('upload', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("mask", {
    "attrs": {
      "id": props.id + '04cec2fa',
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "0",
      "width": "48",
      "height": "48"
    },
    "style": {
      maskType: 'alpha'
    }
  }, [h("path", {
    "attrs": {
      "d": "M48 0H0V48H48V0Z",
      "fill": props.colors[2]
    }
  })]), h("g", {
    "attrs": {
      "mask": 'url(#' + props.id + '04cec2fa' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "M6 24.0083V42H42V24",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M33 15L24 6L15 15",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M23.9917 32V6",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  })])]);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@icon-park/vue/es/icons/Upload.js
// module id = null
// module chunks = 